import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SitemapApiService {
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
  }

  postSitemaps(sitemaps: any[]) {
    return this.httpClient.post(this.baseUrl + 'sitemaps', sitemaps);
  }

  getSitemaps(siteId: any) {
    return this.httpClient.get(this.baseUrl + 'sitemaps/' + siteId);
  }

  updateSitemap(sitemap: any) {
    return this.httpClient.put(this.baseUrl + 'sitemaps/' + sitemap.id, sitemap);
  }
}
